"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.provider.stripe.description': 'Pay with credit cards, debit cards, and digital wallets using Stripe',
};
